import { findHierarchyLevels } from '@/helpers/groups/hierarchy.js'
import { getLocalStorageContentLocale } from '@/helpers/localeHelper'
import { hasDevRoles } from '@/helpers/user.js'

export const currentUserDepartment = (state) => {
  if (state.allResourcesLoaded) {
    return state.currentUser.department
  }
}

export const currentUser = (state) => {
  if (state.allResourcesLoaded) {
    return state.currentUser
  }
}

export const currentCompanyId = (state) => {
  if (state.allResourcesLoaded) {
    return state.currentCompany.id
  }
}

export const companyPositionsList = (state) => {
  if (state.allResourcesLoaded) {
    return state.companyPositions.map((position) => position.name).sort()
  }
}

export const isDevUser = (state) => {
  if (state.allResourcesLoaded) {
    return hasDevRoles(state.currentUser.roles)
  }
}

export const powerBiWorkspaceId = (state) => {
  return state.currentCompany.powerbi_workspace_id
}

export const userHierarchyDepartments = (state) => {
  if (state.allResourcesLoaded) {
    return findHierarchyLevels(state.userDepartments)
  }
}

export const currentCompanyNamekey = (state) => {
  return state.currentCompany.name_key
}

export const contentLocale = (state) => {
  // Force re-computation when contentLocaleTimestamp changes
  // eslint-disable-next-line no-unused-expressions
  state.contentLocaleTimestamp

  const defaultLocale = state.currentCompany.default_locale
  const currentUserLocale = state.currentUser.locale
  const supportedLocales = state.currentCompany.supported_locales.flatMap(
    (locale) => Object.keys(locale)
  )
  const contentLocale = getLocalStorageContentLocale(
    state.currentCompany.name_key
  )

  const isContentLocaleSupported = supportedLocales.includes(contentLocale)
  const isDefaultLocaleSupported = supportedLocales.includes(defaultLocale)
  const isCurrentUserLocaleSupported =
    supportedLocales.includes(currentUserLocale)

  /* 
    Priority:

    1. Content Locale: User has selected a Content Locale in Manager.
    2. User Locale: If the user hasn't selected a Content Locale.
    3. Default Locale: If the User Locale is not among the Supported Locales.
    4. First Supported Locale: If for some odd reason the Default Locale should not
       be among the Supported Locales, it will select the first available Supported Locale.
  */

  if (isContentLocaleSupported) {
    return contentLocale
  } else if (isCurrentUserLocaleSupported) {
    return currentUserLocale
  } else if (isDefaultLocaleSupported) {
    return defaultLocale
  } else {
    return supportedLocales[0]
  }
}
